// LMS access link (Google AI Studio LMS).
// One-line swap: paste the live LMS URL here.
export const LMS_URL = "https://aisho-consulting.ai.studio";
